import { ChartOption } from "@/helper/chart/types/chart-option.type";

export const chartOptionDefault: ChartOption = {
  title: {
    showLabel: false,
  },
};
